type PromiseResult<T> = {
  data: T | null;
  error: any | null;
};

export async function handlePromise<T>(
  promise: Promise<T>
): Promise<PromiseResult<T>> {
  try {
    const data = await promise;
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
}
